

/* -- Misc -- */

import { environment } from "src/environments/environment";

export enum PageStateContext {
    LOGS_OUT,
    NAVS_IN_FROM_NEW_LOGIN,
    NAVS_IN_FROM_OTHER_PAGE
}

export const tileSource = {
    'Open Street Map': 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    'Arc GIS':
        'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
};

/* -- Routes -- */

const SCHEME = environment.production ? 'https://' : 'http://';
const HOSTNAME = environment.production ? 'mocca-technologies.com' : 'localhost';
const ACCORDHOSTNAME = environment.production ? 'mocca-technologies.eu' : 'localhost';
const PORT = environment.production ? '' : ':4567';
const ACCORDPORT = environment.production ? '' : ':4573';

// #region --> Enrolment

export const ENROLMENT_LOGIN = `${SCHEME}${HOSTNAME}${PORT}/mocca/enrolment/login`;                   // POST (CHECKED)
export const OPERATOR_ENROLMENT = `${SCHEME}${HOSTNAME}${PORT}/mocca/enrolment/operator/`;            // POST (CHECKED) & DELETE (CHECKED)
export const PILOT_ENROLMENT = `${SCHEME}${HOSTNAME}${PORT}/mocca/enrolment/pilot/`;                  // POST (CHECKED) & DELETE (CHECKED)
export const VEHICLE_ENROLMENT = `${SCHEME}${HOSTNAME}${PORT}/mocca/enrolment/vehicle/`;              // POST (CHECKED) & DELETE (CHECKED)
export const SESSION_ENROLMENT = `${SCHEME}${HOSTNAME}${PORT}/mocca/enrolment/session/`;              // DELETE (CHECKED)
export const LOGO_ENROLMENT = `${SCHEME}${HOSTNAME}${PORT}/mocca/enrolment/logo/`;                    // POST

// #endregion --> Enrolment

// #region --> Authentication
export const AUTH_LOGIN = `${SCHEME}${HOSTNAME}${PORT}/mocca/login`; //CHECKED

// #endregion --> Authentication

// #region --> Password
export const PASSWORD = `${SCHEME}${HOSTNAME}${PORT}/mocca/password/`; //DONE

// #endregion --> Password

// Organizations
export const OPERATOR = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/`; //DONE

// Sub-Organizations
export const GET_ALL_SUBOPERATOR = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/subOperator/all`; //DONE
export const DELETE_SUBOPERATOR = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/subOperator/`; //DONE

// Pilots
export const PILOT = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/pilot/`; // DONE
export const GET_ALL_PILOT = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/pilot/all`; // DONE
export const PILOT_ROLES = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/pilot/roles`;

// Vehicles
export const VEHICLE = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/vehicle/`; // DONE
export const GET_ALL_VEHICLE = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/vehicle/all`; // DONE

// Transfer
export const PILOT_TRANSFER = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/transfer/pilot/`; // DONE
export const VEHICLE_TRANSFER = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/transfer/vehicle/`; // DONE

// Sessions
export const SESSION = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/session/`; // DONE
export const GET_USER_SESSIONS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/session/pilot/`; // DONE
export const GET_VEHICLE_SESSIONS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operator/session/vehicle/`; // DONE

// Log
export const PILOT_LOGBOOK = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/logbook/pilot/`; // DONE
export const UPDATE_LOG_ACTIVITY = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/logbook/pilot/activity`; // DONE
export const VEHICLE_LOGBOOKS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/logbook/vehicle/`; // DONE
export const BATTERY_LOGBOOKS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/logbook/battery/`; // DONE
export const ALL_BATTERIES = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/logbook/battery/all`; // DONE
export const BATTERY_CHARGING_REGISTER = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/logbook/battery/chargingRegister`; // DONE

// Operations
export const LAST_OPERATION_ALL = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operation/completed`; // DONE
export const ACTIVE_OPERATION_ALL = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operation/active`; // DONE
export const OPERATIONS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operation/`; // DONE
export const ARCHIVE_OPERATION = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operation/archive`; // DONE
export const ACTIVE_LIST = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operation/activeList`; // DONE
export const LAST_UPDATE = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/operation/lastUpdate`; // DONE

// Region Maps
export const ALL_REGION_MAPS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/regionMaps/all`; // DONE
export const REGION_MAPS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/regionMaps/`; // DONE

// AutopilotOperations
export const APOPERATIONS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/apOperation/`; // DONE
export const ALL_APOPERATIONS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/apOperation/all`; // DONE
export const DOWNLOAD_ONE_APTRAJECTORY = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/apOperation/apTrajectory`; // DONE

// ApTrajectories
export const ALL_APTRAJECTORIES = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/apTrajectory/all`; // DONE
export const APTRAJECTORIES = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/apTrajectory/`; // DONE
export const OBTAIN_APTRAJECTORY_FROM_FILE = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/apTrajectory/check`; // DONE

// Scheduled Operations

export const ALL_SCHEDULED = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/scheduledOperation/all`; // DONE
export const SCHEDULED_OPERATIONS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/scheduledOperation/`; // DONE

export const DOWNLOAD_APK = `${SCHEME}${HOSTNAME}/mocca_apk/MOCCA_MobileSDK.apk`; // DONE

// Planning
export const ALL_VERTIPORTS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/planning/vertiports/all`; // DONE
export const GET_ACTIVATE_VERTIPORTS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/planning/vertiports/activate`; // DONE
export const ALL_AIRSPACE_AREAS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/planning/airspaceAreas/all`; // DONE
export const GET_ACTIVATE_AIRSPACE_AREAS = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/planning/airspaceAreas/activate`; // DONE
export const ALL_DELIVERIES = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/planning/delivery/all`; // DONE
export const GET_ACTIVATE_DELIVERIES = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/planning/delivery/activate`; // DONE
export const POST_CREATE_DESIGN = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/planning/designOperation`; // DONE

// Files
export const ORGANIZATION_LOGO = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/files/organization/logo/`; // DONE
export const VEHICLE_IMAGE = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/files/vehicle/image/`; // DONE
export const PILOT_IMAGE = `${SCHEME}${HOSTNAME}${PORT}/mocca/api/files/pilot/image/`; // DONE

// ACCORD

export const INFRASTRUCTURE = `${SCHEME}${ACCORDHOSTNAME}${ACCORDPORT}/accordInterface/api/infrastructure/`;
export const NEAR_INFRASTRUCTURES = `${SCHEME}${ACCORDHOSTNAME}${ACCORDPORT}/accordInterface/api/infrastructure/near/`;
export const NEAR_URBAN_AREAS = `${SCHEME}${ACCORDHOSTNAME}${ACCORDPORT}/accordInterface/api/urbanArea/near/`;
export const TRACK_NETWORK = `${SCHEME}${ACCORDHOSTNAME}${ACCORDPORT}/accordInterface/api/trackNetwork/`;
export const ALL_TRACK_NETWORKS = `${SCHEME}${ACCORDHOSTNAME}${ACCORDPORT}/accordInterface/api/trackNetwork/all/`;
export const TRACK_NETWORK_SEGMENTS_NEAR_LOC = `${SCHEME}${ACCORDHOSTNAME}${ACCORDPORT}/accordInterface/api/trackNetwork/near/segments/`;
export const TRACK_NETWORK_NEAR_LOC = `${SCHEME}${ACCORDHOSTNAME}${ACCORDPORT}/accordInterface/api/trackNetwork/near/`;



